import React from "react"
import Mailchimp from "react-mailchimp-form"

import FormStyles from "./subform.module.css"

export const SubscribeForm = () => {
  return (
    <div>
      <Mailchimp
        action={null}
        fields={[
          {
            name: "EMAIL",
            placeholder: "Your email address",
            type: "email",
            required: true,
          },
        ]}
        messages={{
          sending: "Sending...",
          success: "Thank you for subscribing!",
          error: "An unexpected internal error has occurred.",
          empty: "You must write an e-mail.",
          button: "Subscribe",
        }}
        className={FormStyles.form}
      />
    </div>
  )
}
